export default __webpack_public_path__ + "static/media/MidSteppesMap.80c5cde3.jpg";